//import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, trigger, animate, transition, style, keyframes } from '@angular/core';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewEncapsulation } from '@angular/core';
import {trigger, state, animate, transition, style,keyframes} from '@angular/animations';
import { EditPopup } from '../edit-popup';
import { SharedService } from '../shared.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalInfo, FPMessage, Severities, RoleAccess } from './../.././shared/shared.model';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { multipleEmailValidator } from '../custom-validators/custom-validator.directive';
import { WoService } from '../../work-order/work-order.service';
import { CapitalizeFirstPipe } from './../.././shared/pipes/custom-pipes.pipe';

@Component({
    selector: 'sentmail-popup',
    templateUrl: 'sent-mail-popup.html',
    styleUrls: ['./dispatch-board.css'],
    animations: [
        trigger('isVisibleChanged', [
            transition('void => *', [
                animate(600, keyframes([
                    style({ opacity: 0, transform: 'translateY(-200px)', offset: 0 }),
                    style({ opacity: 1, transform: 'translateY(25px)', offset: .75 }),
                    style({ opacity: 1, transform: 'translateY(0)', offset: 1 }),
                ]))
            ])
        ])
    ],
    encapsulation: ViewEncapsulation.None
})
export class SentMailPopupComponent implements OnInit, EditPopup {
    @Output() done = new EventEmitter();
    public frmEmail: FormGroup;
    @Input() workorderid: number;
    @Input() workJobId: number;
    @Input() companyid: number;
    @Input() techid: number;
    @Input() ScreenDetails: string;
    @Input() LoginID: number;
    message: FPMessage;

    constructor(private sharedService: SharedService, protected translate: TranslateService,
        protected _woService: WoService, protected formBuilder: FormBuilder) {
        //super(sharedService, translate); 
    }

    ngOnInit() {
        this.frmEmail = this.formBuilder.group({
            OthersEmail: ['', multipleEmailValidator],
        });
    }

    sentmail() {        
        let mailaddress = this.frmEmail.controls['OthersEmail'].value;
        this._woService.PDFConvert(this.companyid, this.workorderid, this.workJobId, this.techid, mailaddress, this.ScreenDetails)
            .subscribe(s => {                
                this.message = s.Message;
                if (s.Message.Severity == Severities.success) this.close(true); else this.close(false);
            });
    }

    close(success?: boolean) {
        if (success || success == false) {
            if (this.message.MessageCode == "1001" || this.message.MessageCode == "1002") {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail:  this.translate.instant(this.message.MessageCode)
                });
            }
            
            else {
                this.sharedService.notification.emit({
                    severity: Severities[this.message.Severity],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                    detail: this.translate.instant(this.message.MessageCode)
                });
            }
        }
        if (success == null || success == undefined)
            this.done.emit(true);
    }
}